import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mail-draft",
  "use": "mail-draft-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"mail-draft\">\n  <path d=\"M21.99,8 C21.99,7.28 21.62,6.65 21.05,6.3 L12,1 L2.95,6.3 C2.38,6.65 2,7.28 2,8 L2,18 C2,19.1 2.9,20 4,20 L20,20 C21.1,20 22,19.1 22,18 L21.99,8 Z M12,13 L3.74,7.84 L12,3 L20.26,7.84 L12,13 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol